// extracted by mini-css-extract-plugin
export default {"buttonContainer":"styles_buttonContainer__OMviC","wrapper":"styles_wrapper__HtF0Y"};